import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, Table, Tag, Form } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import  Modal  from '@mui/material/Modal';
import { DatePicker, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { DataGrid, GridCellParams, GridSortDirection, GridToolbar } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import { makeStyles } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { UIStore } from "../store/store";
import Equipment from './Equipment';
import { keyframes } from 'styled-components';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar'

const PropertyDetails: React.FC = (props: any) => {
  const currentProperty = UIStore.useState(s => s.SelectedProperty);
 
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    imageList: {
      flexWrap: 'nowrap',
      // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
      transform: 'translateZ(0)',
    },
    paper: {
      position: 'absolute',
      
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    img: {
    
    }
  }));

  const classes = useStyles();

  const amenitiesColumns = [

    { field: 'id', headerName: 'ID', width: 200 },
    { field: 'Name', headerName: 'Name', width: 200 },
    { field: 'Room', headerName: 'Room', width: 200 },
    { field: 'Property', headerName: 'Property', width: 200 },
    { field: 'Status', headerName: 'Status', width: 200 },
  ];

  const equipmentColumns = [

    { field: 'id', headerName: 'ID', width: 200 },
    { field: 'Name', headerName: 'Name', width: 200 },
    { field: 'Status', headerName: 'Status', width: 200 },
  ];

 
  useEffect(() => {
    (async () => {
      setState(currentProperty); 
     // console.log(currentProperty);  
    })()
  }, [])




 
  useIonViewDidEnter(() => {
    //   axios.get('https://dev.northroom.co.za/api/bizprop/lessors/all')
    //     .then(function (response) {
    //       // handle success
    //       console.log(response.data);
    //       SetData(response.data);
    //     })
    //     .catch(function (error) {
    //       // handle error
    //       console.log(error);
    //     })
    //     .then(function () {
    //       // always executed
    //     });
  });


  const { name } = useParams<{ name: string; }>();
  
  const user = JSON.parse(localStorage.getItem("userobject") || '{}');
  const [PropertyObject, setState] = useState({});

  const [open, setOpen] = React.useState(false);
  const [img, setImg] = React.useState({});

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handlePicClick = (e:any) => {
    //console.log(e.target.src)
    setImg(e.target.src)
    handleOpen();
  };

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setState(prevState => ({
      ...prevState,
      [name]: value
    }));

    setState(prevState => ({
      ...prevState,
      userid: user.id
    }));
  };

  return (

    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              title="Property Details"
            />
          </IonRow>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen >
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="11" style={{ paddingLeft: "40px" }}>
                <IonCard>
                  <IonCardHeader>
                  <IonCol>
                        <Link to={{ pathname: "/Property"}}  >
                    <Button
            variant="contained"
            color="primary"
            size="small"    
            style={{ marginLeft: 25 }} > Back</Button>       
       </Link>
       </IonCol>
                    <br></br>
                    <Modal
                      className={classes.modal}
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="simple-modal-title"
                      aria-describedby="simple-modal-description"
                    >
                       <div  className={classes.paper}>
                       {/* @ts-ignore */}
                        <img className={ classes.img} src={img} alt="Property" />
                        </div>
                      </Modal>

                  </IonCardHeader>

                  <IonCardContent>
        
                    <IonRow>           
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Name" variant="outlined" value={currentProperty.Name} onChange={handleChange} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Address" variant="outlined" value={currentProperty.Address} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Country" variant="outlined" value={currentProperty.Country} />
                      </IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Province" variant="outlined" value={currentProperty.Province} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="City" variant="outlined" value={currentProperty.City} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Suburb" variant="outlined" value={currentProperty.Suburb} />
                      </IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Property Description" variant="outlined" value={currentProperty.Description} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Property Type" variant="outlined" value={currentProperty.PropertyType} />
                      </IonCol>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Property Uses" variant="outlined" value={currentProperty.PropertyUses} />
                      </IonCol>
                    </IonRow>

                    <IonRow>
                      <IonCol>
                        {/* @ts-ignore */}
                        <TextField id="outlined-basic" label="Furnished Type" variant="outlined" value={currentProperty.FurnishedType} />
                      </IonCol>
                      
                    </IonRow>


                    <br></br>
                    <IonRow>
                      <IonRow>
                        <IonCol>
                          <h2><strong>List of Amenities</strong></h2>
                          <div style={{ height: 400, width: '80vw', paddingRight: "2vw" }}>
                           
                            <DataGrid
                             /* @ts-ignore */
                              rows={currentProperty.ammenities}
                              columns={amenitiesColumns}
                              components={{
                                Toolbar: GridToolbar,
                              }}
                              sortModel={[
                                {
                                  field: 'Name',
                                  sort: 'asc' as GridSortDirection,
                                },
                              ]}
                            />
                          </div>
                        </IonCol>
                      </IonRow>

                      <IonRow>
                        <IonCol>
                          
                        </IonCol>
                      </IonRow>

                      <IonRow>
                        <IonCol>
                          <h2><strong>List of Equipment</strong></h2>
                          <div style={{ height: 400, width: '80vw', paddingRight: "2vw" }}>

                            <DataGrid
                            /* @ts-ignore */
                              rows={currentProperty.equipment}
                              columns={equipmentColumns}
                              components={{
                                Toolbar: GridToolbar,
                              }}
                              filterModel={{
                                items: [
                                  { columnField: 'Name', operatorValue: 'contains', value: '' },
                                ],
                              }}
                            />
                          </div>
                        </IonCol>
                                    
                      </IonRow>
                      <IonRow>
                        <IonCol>
                        <h2><strong>Property Images</strong></h2>
                          <ImageList className={classes.imageList} cols={2.5}>
                              {/* @ts-ignore */}
                            {currentProperty.photos.map((item) => (                            
                              <ImageListItem key={item.img}>
                                <img src={item.FilePath} alt={"Property"} onClick={(e)=>handlePicClick(e)}/>
                              </ImageListItem>
                              
                            ))}
                          </ImageList>
                        </IonCol>
                      </IonRow>
                   

                    </IonRow>              
                    {/* <Link to="/dashboard">
  <Button type="primary">View lessor details</Button>
  </Link> */}
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>

        </Space>
      </IonContent>
    </IonPage>

  );
}

export default PropertyDetails;

